import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { ActiveUserState } from './active-user.state';
import { ToolAccess } from '../../models/user';

export function withActiveUserSelectors() {
  return signalStoreFeature(
    {
      state: type<ActiveUserState>(),
    },
    withComputed(({ user, isLoggedIn }) => ({
      checkLogin: computed(() => isLoggedIn()),
      isAdmin: computed(() => {
        const userInstance = user();
        if (!userInstance) return false;
        return userInstance.isAdmin || userInstance.level >= 10;
      }),
      isSuperAdmin: computed(() => user()?.isSuperAdmin ?? false),
      workspaces: computed(() => user()?.workspaces ?? false),
      noToolAccessFallback: computed(() => {
        const activeUser = user();
        if (!activeUser) return false;
        if (activeUser.level > 0) return false;
        // Ensure toolAccess exists and is an object
        if (
          !activeUser?.toolAccess ||
          typeof activeUser.toolAccess !== 'object'
        ) {
          return true; // Default to true if toolAccess is not defined
        }

        // Check if all keys in toolAccess are false
        return (
          Object.keys(activeUser.toolAccess) as (keyof ToolAccess)[]
        ).every(key => activeUser.toolAccess[key] === false);
      }),
    }))
  );
}
